<script>
import PageImage from "../pages/page-image";
import Multiselect from "@/components/RMultiselect.vue";
import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {
    PageImage,
    Multiselect,
  },
  props: {
    page: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
      listPersons: []
    };
  },
  beforeMount() {
    if (sessionStorage.getItem('persons'))
      this.listPersons = JSON.parse(sessionStorage.getItem('persons'));
    else {
      api.get('persons').then((response) => {
        this.listPersons = response.data.data;
        sessionStorage.setItem('persons', JSON.stringify(this.listPersons));

        return this.listPersons;
      });
    }
  },
  methods: {
    formatAdresse(item) {
      let adresse = '';

      if (item.Adresse !== '' && item.Adresse !== ' ')
        adresse += `<a href="#">${item.Adresse}</a>`;
      if (item.Ville !== '' && item.Ville !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Ville}</a>`;
      if (item.Region !== '' && item.Region !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Region}</a>`;
      if (item.Pays !== '' && item.Pays !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Pays}</a>`;

      return adresse;
    },
    formatDate(item) {
      let date = '';

      if (item.DateJour !== '' && item.DateJour !== ' ')
        date += item.DateJour;
      if (item.DateMois !== '' && item.DateMois !== ' ')
        date += (date !== '' ? '/' : '') + item.DateMois;
      if (item.DateAnnee !== '' && item.DateAnnee !== ' ')
        date += (date !== '' ? '/' : '') + item.DateAnnee;
      if (item.DetailDate !== '' && item.DetailDate !== ' ')
        date += (date !== '' ? ', ' : '') + item.DetailDate;

      return date;
    },
    formatTheme(item) {
      let theme = '';

      if (item.Theme !== '' && item.Theme !== ' ')
        theme += `<a href="#">${item.Theme}</a>`;
      if (item.DetailTheme !== '' && item.DetailTheme !== ' ')
        theme += (theme !== '' ? ', ' : '') + item.DetailTheme;

      return theme;
    },
    getNumAlbum(item) {
      let imageNumber = item.NumPageAlbum;
      let annee = imageNumber.substr(imageNumber.length - 2);

      return '19' + annee;
    },
    async submitForm() {
      this.page.id = this.page.CodePageAlbum;

      api.save('pages', this.page)
          .then((response) => {
            if (response.status !== 200)
              this.$emit('error');
            else
              this.$emit('submitted');
          })
          .catch(() => {
            this.$emit('error');
          });
    },
    formatSelectListPersons(person) {
      return `${person.last_name} ${person.first_name}`
    },
  }
};
</script>

<template>
  <b-card no-body class="mb-0">

    <b-form ref="form_page">
      <b-card-body>
        <b-row no-gutters class="align-items-center">
          <b-col md="4">
            <page-image :page="page"></page-image>
          </b-col>
          <b-col md="8">
            <b-form-group label="Numero page" label-for="formrow-NumPageAlbum-input">
              <b-form-input id="formrow-NumPageAlbum-input" type="text" v-model="page.NumPageAlbum"></b-form-input>
            </b-form-group>

            <div class="row">
              <div class="col-lg-4">
                <b-form-group label="Jour" label-for="formrow-datejour">
                  <b-form-input id="formrow-datejour" type="number" v-model="page.DateJour"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4">
                <b-form-group label="Mois" label-for="formrow-datemois">
                  <b-form-input id="formrow-datemois" type="number" v-model="page.DateMois"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4">
                <b-form-group label="Année" label-for="formrow-dateannee">
                  <b-form-input id="formrow-dateannee" type="number" v-model="page.DateAnnee"></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Lieu" label-for="formrow-lieu">
                  <b-form-input id="formrow-lieu" type="text" v-model="page.Lieu"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group label="Région" label-for="formrow-region">
                  <b-form-input id="formrow-region" type="text" v-model="page.Region"></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4">
                <b-form-group label="Adresse" label-for="formrow-adresse">
                  <b-form-input id="formrow-adresse" type="text" v-model="page.Adresse"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4">
                <b-form-group label="Ville" label-for="formrow-ville">
                  <b-form-input id="formrow-ville" type="text" v-model="page.Ville"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4">
                <b-form-group label="Pays" label-for="formrow-pays">
                  <b-form-input id="formrow-pays" type="text" v-model="page.Pays"></b-form-input>
                </b-form-group>
              </div>
            </div>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Personnes présentes sur la page" label-for="formrow-personnes-input">
                  <multiselect
                      id="formrow-personnes-input"
                      v-model="page.persons"
                      :options="listPersons"
                      label="last_name"
                      track-by="id"
                      select-label=""
                      :multiple="true"
                      :custom-label="formatSelectListPersons"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="Inscription" label-for="formrow-inscription-input">
              <b-form-textarea id="formrow-inscription-input" type="text" v-model="page.Inscription"></b-form-textarea>
            </b-form-group>

            <b-form-group label="Commentaire" label-for="formrow-commentaire-input">
              <b-form-textarea id="formrow-commentaire-input" type="text" v-model="page.Commentaire"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-card-footer class="text-right">
        <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
        <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
      </b-card-footer>
    </b-form>
  </b-card>
</template>